export default __webpack_public_path__ + "static/media/trusted-by-main.6d013f44.jpg";